import {qsa, qs, addGlobalEventListener, createElement, appendStyle, appendScript} from './utils/domUtils';
import initDataTable from "./table/datatable";
import initWizardForm from "./forms/wizard-form";
import initCharts from "./charts/chartjs";
import IMask from "imask";

(function (window, undefined) {
  'use strict';
    window.axios = require('axios');
    window.IMask = IMask

    window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

  /*
  NOTE:
  ------
  PLACE HERE YOUR OWN JAVASCRIPT CODE IF NEEDED
  WE WILL RELEASE FUTURE UPDATES SO IN ORDER TO NOT OVERWRITE YOUR JAVASCRIPT CODE PLEASE CONSIDER WRITING YOUR SCRIPT HERE.  */
    //initiate flatpickr dynamically
    if (qs('.flatpickr')){
        import('../../vendors/js/pickers/flatpickr/flatpickr.min').then(() => {
            let flatpickrCSS = createElement('link', {
                rel: 'stylesheet',
                type: 'text/css',
                href: '/vendors/css/pickers/flatpickr/flatpickr.min.css'
            })
            document.head.appendChild(flatpickrCSS);
            let flatPickers = qsa('.flatpickr')
            flatPickers.forEach(item => {
                // basic
                let options = {};
                if ('dateRange' in item.dataset){
                    options.mode = 'range';
                    options.dateFormat = 'd/m/Y';
                    options.onChange = (selectedDates, dateStr, instance) => {
                        if (selectedDates.length === 1){
                            dateStr = [dateStr, dateStr].join(' to ');
                        }
                        let inputField = instance.input;
                        inputField.value = dateStr.replace('to', '-');
                    }
                }

                if ('blockFuture' in item.dataset){
                    options.enable = [
                        function(date){
                            let now = new Date()
                            return date.getTime() < now.getTime();

                        }
                    ]
                }
                $(item).flatpickr(options)
            })
        })
    }

    // init select2
    if (qs('.select2')){
        appendScript('/vendors/js/forms/select/select2.full.min.js').then(() => {
            appendStyle('/vendors/css/forms/select/select2.min.css')
            // init default select2 selectors
            let select2Elements = qsa('.select2')
            select2Elements.forEach(item => {
                let options = {};
                if (item.multiple){
                    options.closeOnSelect = false
                } else {
                    options.allowClear = true
                    let disabledOption = [...item.options].find(option => option.disabled);
                    options.placeholder = disabledOption?.innerText || 'בחר';
                }
                if ('taggable' in item.dataset){
                    options.tags = true
                }

                // change parent if in modal
                if (item.closest('.modal')){
                    options.dropdownParent = $(item.closest('.modal'));
                }

                if (item.dataset.maxSelect){
                    options.maximumSelectionLength = item.dataset.maxSelect
                }

                if (item.dataset.ajax){
                    let ajaxOptions = {
                        url: `/api/search/${item.dataset.ajax}`,
                        dataType: 'json',
                        delay: 100,
                        data(params){
                            let searchEvent = new CustomEvent('shamaim:search', {
                                detail: params.term
                            })

                            item.dispatchEvent(searchEvent)
                            return {
                                search: params.term,
                                type: 'public',
                                page: params.page
                            }
                        },
                        processResults(data, params){
                            if(!data.data.length){
                                let noResultsEvent = new CustomEvent('shamaim:no-result', {
                                    detail: {
                                        search: params.term
                                    }
                                })

                                item.dispatchEvent(noResultsEvent)
                            }
                            return {
                                results: data.data
                            }
                        }
                    }
                    options.ajax = ajaxOptions;
                }
                options.language = {
                    maximumSelected: function (args) {
                        return `אפשר לבחור רק ${args.maximum} ממליצים`
                    }
                }
                $(item).select2(options);

                $(item).on('select2:select', (e) => {
                    let changeEvent = new CustomEvent('shamaim:select', {
                        detail: e.params.data
                    })

                    item.dispatchEvent(changeEvent)
                })

                $(item).on('select2:unselect', (e) => {
                    let changeEvent = new CustomEvent('shamaim:unselect')

                    item.dispatchEvent(changeEvent)
                })

                $(item).on('change', (e) => {
                    let changeEvent = new Event('shamaim:change')

                    item.dispatchEvent(changeEvent)
                })

                if (!item.multiple){
                    $(item).on('select2:select', function (e){
                        let selectContainer = $(this).siblings('.select2-container')[0];
                        $(selectContainer).find('.select2-selection__arrow').hide();
                    })

                    $(item).on('select2:clear', function(e){
                        $(item).val(null).trigger('change');
                        let selectContainer = $(this).siblings('.select2-container')[0];
                        $(selectContainer).find('.select2-selection__arrow').show();
                    });

                    if ($(item).val()){
                        let selectContainer = $(item).siblings('.select2-container')[0];
                        $(selectContainer).find('.select2-selection__arrow').hide();
                    }
                }
            })
        })
    }

    qsa('input[data-phone-mask]').forEach(input => {
        IMask(
            input,
            {
                mask: '{X}00-0000000',
                definitions: {
                    X: {
                        mask: '0',
                        displayChar: '0',
                        placeholderChar: '0'
                    }
                }
            }
        )
    })

    qsa('.bs-stepper-form').forEach((form) => {
        initWizardForm(form)
    })

    initDataTable().then(() => {
    });

    initCharts()

})(window);
